import { AxiosError } from "axios";

import { getTokenClientes } from "../../Store/storages/AuthenticationStorage";
import { apiClientes } from "../../config/api";

export const getManuaisPlanoEmpresa = async (): Promise<any> => {
    try {
        const Authorization = `Bearer ${await getTokenClientes()}`;
        const headers = { Authorization };
        const response = await apiClientes.get("/config/getmanuaisplanoempresa", { headers });
        return response.data;
    } catch (error) {
        throw (error as AxiosError)?.response?.data;
    }
};